export default __webpack_public_path__ + "static/media/robin.40aa559b.png";